/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Exercise_Preference_Limit_ReachedInputs */

const en_us2_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can mark up to ${i?.max} exercises. Clear one first.`)
};

const pt_br2_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você pode marcar até ${i?.max} exercícios. Desmarque um antes.`)
};

const es_419_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes marcar hasta ${i?.max} ejercicios. Desmarca uno primero.`)
};

const pt_pt2_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podes marcar até ${i?.max} exercícios. Desmarca um primeiro.`)
};

const fr_fr2_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu peux marquer ${i?.max} exercices au maximum. Retires-en un d'abord.`)
};

const de_de2_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst bis zu ${i?.max} Übungen markieren. Entferne zuerst eine Markierung.`)
};

const it_it2_exercise_preference_limit_reached = /** @type {(inputs: Exercise_Preference_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puoi segnare al massimo ${i?.max} esercizi. Togline uno prima.`)
};

/**
* | output |
* | --- |
* | "You can mark up to {max} exercises. Clear one first." |
*
* @param {Exercise_Preference_Limit_ReachedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_preference_limit_reached = /** @type {((inputs: Exercise_Preference_Limit_ReachedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Preference_Limit_ReachedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_preference_limit_reached(inputs)
	if (locale === "es-419") return es_419_exercise_preference_limit_reached(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_preference_limit_reached(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_preference_limit_reached(inputs)
	if (locale === "de-DE") return de_de2_exercise_preference_limit_reached(inputs)
	if (locale === "it-IT") return it_it2_exercise_preference_limit_reached(inputs)
	return en_us2_exercise_preference_limit_reached(inputs)
});
export { exercise_preference_limit_reached as "exercise_preference.limit_reached" }